var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.switching)?_c('div',[_vm._v(_vm._s(_vm.text))]):(!_vm.hasCookie)?_c('div',[_vm._v(_vm._s(_vm.text)+"即将跳往登录页（"+_vm._s(_vm.num)+"）")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }